import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./Icon.style";
interface IIconProps {
  name?: string;
  size?: number;
}

export const Icon: FC<IIconProps & HTMLAttributes<HTMLSpanElement>> = ({
  name,
  size = 24,
  ...otherProps
}) => {
  const classes = useStyles();

  if (!name) return null;

  return (
    <span
      {...otherProps}
      style={{
        ...otherProps.style,
        fontSize: size,
        lineHeight: `${size}px`,
      }}
      className={clsx(otherProps.className, classes.root, name)}
    />
  );
};
